import { openDB } from "idb"
import IndexedDB from "./IndexedDB"

export default class IndexedDBAsync extends IndexedDB {
    constructor(databaseName, stores, version) {
        super(databaseName, stores, version)
        super.openDB()
    }

    _openDB() {
        return super.openDB()
    }

    async openDB() {
        this.db = await openDB(this.databaseName, this.version, {
            upgrade(db) {
                this.stores.forEach((o) => {
                    const store = db.createObjectStore(o.name, o.option);
                    if (o.indexes) {
                        o.indexes.map(i => store.createIndex(i.name, i.name, {unique: false}))
                    }
                });
            },
            blocked() {console.log("database blocked")},
            blocking(e) {console.log("database blocking: ", e)}
        })
        return this
    }

    addItem(storeName, data) {
        if (!this.db) 
            throw Error("can`t find db")

        return this.db.add(storeName, {...data, createDateTime: Date.now()})
    }

    addItems(storeName, data) {
        if (!this.db) 
            throw Error("can`t find db")
        if(!Array.isArray(data)) 
            throw Error("you can add only array")

        const trx = this.db.transaction(storeName, 'readwrite')
        const createDateTime = Date.now()
        return Promise
        .all([...data.map(i => trx.store.add({...i, createDateTime: Date.now()})), trx.done])
        .then(
            (res) => {},        
            (reason) => {throw Error(reason)}
        )
    }

    getItem(storeName, key) {
        return this.db.get(storeName, key)
    }

    putItem(storeName, value) {
        return this.db.put(storeName, {...value, updateDateTime: Date.now()})
    }

    deleteItem(storeName, key) {
        return this.db.delete(storeName, key)
    }

    deleteItems(storeName, keys) {
        if (!this.db) 
            throw Error("can`t find db")
        if(!Array.isArray(keys)) 
            throw Error("you can delete only array")

        const trx = this.db.transaction(storeName, 'readwrite')
        return Promise
        .all([...keys.map(i => trx.store.put(i)), trx.done])
        .then(
            (res) => {},
            (reason) => {throw Error(reason)}
        )
    }

    putItems(storeName, data) {
        if (!this.db) 
            throw Error("can`t find db")
        if(!Array.isArray(data)) 
            throw Error("you can put only array")

        const trx = this.db.transaction(storeName, 'readwrite')
        const updateDateTime = Date.now()
        return Promise.all([...data.map(i => trx.store.put({...i, updateDateTime}))])
        .then(
            (res) => {return res},
            (reason) => {throw Error(reason)}
        )
    }

    getItems(storeName) {
        if (!this.db) 
            throw Error("can`t find db")

        return this.db.getAll(storeName)
    }


    async addOrPutItem(storeName, data, key) {
        let res
        try {
            res = await this.getItem(storeName, key)
                .then(r => {
                    if (!r)
                        throw Error()
                    return this
                        .putItem(storeName, {...data, updateDateTime: Date.now()})
                })
        } catch (e) {
            // console.error(storeName, data, key, e)
            res = this.addItem(
                storeName
                , {...data, createDateTime: Date.now()}
            )
        }

        return res
    } 

}